import React, { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { ResetPassword } from "../../actions/LoginAction";
import swal from "sweetalert";

const ResetPasswordForm = () => {
  const params = useParams();
  const navigate = useNavigate();
  const [password, setPassword] = useState({value:'',error:''});
  const [confirmPassword,setConfirmPassword]=useState({value:'',error:''})

  const [loading,setLoading] = useState();

  const validation = () => {
    let formIsValid = true


    if (!password.value) {
        formIsValid = false
        let msg = "Please enter your password"
        setPassword({...password,error:msg})
    }
    if(password.value.length <= 7){
      formIsValid = false
      let msg = "Password must contain at least 8 characters"
      setPassword({...password,error:msg})
  }
    // confirm pass
    if (!confirmPassword.value){
      formIsValid = false
      let msg = "Please confirm you password"
      setConfirmPassword({...confirmPassword,error:msg})
  }
  if (confirmPassword.value!==password.value){
      formIsValid = false
      let msg = "Password is not matching with your new password"
      setConfirmPassword({...confirmPassword,error:msg})
  }


    if(formIsValid){
      if(formIsValid){
        setPassword({...password,error:''})
        setConfirmPassword({...confirmPassword,error:''})

    }
    }
    return formIsValid
}


  const submitLoginHandler = async(e) => {
    e.preventDefault();

    if(validation()){

        const data = {
          reset_code : params?.resetCode,
          new_password: password.value,
          };
          
          setLoading(true)
          try {
            await ResetPassword(data).then((res) => {
              if(res.status){
                setLoading(false)
                swal('Password Updated Successfully!','','success')
                navigate('/login')
              }
              else{
                swal(res.message,'','error')
                setLoading(false)
              }
            });
          } catch (error) {
            swal('Something went wrong!','',"error")
          }
    }
    
  };

  return (
    <form onSubmit={submitLoginHandler} className="w-100">

      <div className="mb-3">
        <label htmlFor="pass" className="form-label">
          New Password
        </label>
        <input
          type="password"
          className="form-control"
          id="pass"
          value={password.value}
          onChange={e => setPassword({...password,value:e.target.value,error:''})}
          placeholder="Enter new password"
        />
        {password?.error.length > 0 && <small className="invalid-field text-danger fw-semibold mt-1">{password.error}</small>}

      </div>

      <div className="mb-3">
        <label htmlFor="Confirmpass" className="form-label">
          Confirm Password
        </label>
        <input
          type="password"
          className="form-control"
          id="Confirmpass"
          value={confirmPassword.value}
          onChange={e => setConfirmPassword({...confirmPassword,value:e.target.value,error:''})}
          placeholder="Confirm your password"
        />
        {confirmPassword?.error.length > 0 && <small className="invalid-field text-danger fw-semibold mt-1">{confirmPassword.error}</small>}

      </div>

      <div className="mb-3">
        {/* <button type="submit" className="btn btn-primary d-block w-100">
          Login
        </button> */}
        {loading ? <button className="btn btn-primary w-100 d-block" disabled type="button">
                            <span className="spinner-grow spinner-grow-sm me-2" aria-hidden="true"></span>
                                Submitting please wait...</button> : 
                            <button className="btn btn-primary d-block w-100" type="submit">Submit</button>}
      </div>

    </form>
  );
};

export default ResetPasswordForm;
